var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQualifiersMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3925_131893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -42,
    y: 0,
    width: 128,
    height: 94
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 127.234,
    height: 94,
    transform: "matrix(-1 0 0 1 85.234 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3925_131893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-48.272 94H48.8233C63.8111 71.7626 71.209 56.4927 71.4679 23.0637L71.468 3.05176e-05H-48.272V94Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.3639 94H19.1733C33.6725 80.3155 54.5251 59.5442 57.376 17.1872L57.3761 3.05176e-05H-62.3639V94Z",
    fill: "#B287FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.3743 94H-27.5008C-4.85612 88.1352 41.6552 58.974 43.3657 3.05176e-05H-76.3743V94Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.851 74.9394C-91.851 74.9394 -82.3206 84.7141 -42.9775 74.9394C-3.63437 65.1647 21.454 36.4922 27.889 7.82013e-05C34.3241 -36.4921 -91.851 7.82013e-05 -91.851 7.82013e-05V74.9394Z",
    fill: "#4A148C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.796 56.6208C-104.796 56.6208 -95.2658 66.3955 -55.9227 56.6208C-16.5796 46.8461 8.50883 18.1737 14.9439 -18.3185C21.3789 -54.8107 -104.796 -18.3185 -104.796 -18.3185V56.6208Z",
    fill: "#D60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.2 36.7456C-116.2 36.7456 -106.67 46.5203 -67.3264 36.7456C-27.9832 26.9709 -2.89485 -1.70158 3.54017 -38.1937C9.97518 -74.6859 -116.2 -38.1937 -116.2 -38.1937V36.7456Z",
    fill: "#B0EB00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifiersMobile);
export default __webpack_public_path__ + "static/media/qualifiersMobile.b68d957d7d950fb9e765db3870d4d0cf.svg";
export { ForwardRef as ReactComponent };